import * as React from 'react';

import { Typography } from '@mui/material';

import { pStyle } from '../tfa-auth/pages/styles';

type FooterProps = {
  hasAvatar?: boolean;
  hasSearch?: boolean;
  hasIcon?: boolean;
  hasBurger?: boolean;
};

export const Footer: React.FC<FooterProps> = (props) => {
  return (
    <footer
      style={{
        boxShadow: '0 0 1px 0',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        backgroundColor: '#fff',
      }}
    >
      <Typography
        style={{
          ...pStyle,
          fontWeight: '600',
          color: 'black',
          fontSize: '14px',
          marginBottom: '0px',
        }}
      >
        v{process.env.REACT_APP_VERSION}
      </Typography>
    </footer>
  );
};
